import { createAction, props } from '@ngrx/store';
import { IProducts } from '../models/products.model';

export const loadUpcomingProductsForSomeoneElse = createAction(
  '[UpcomingProductsForSomeoneElse] Load UpcomingProductsForSomeoneElse',
  props<{ request: string }>()
);

export const loadUpcomingProductsForSomeoneElseSuccess = createAction(
  '[UpcomingProductsForSomeoneElse] Load UpcomingProductsForSomeoneElse Success',
  props<{ response: IProducts[] }>()
);

export const loadUpcomingProductsForSomeoneElseFailure = createAction(
  '[UpcomingProductsForSomeoneElse] Load UpcomingProductsForSomeoneElse Failure',
  props<{ error: Error | any }>()
);
